import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as Chain } from '../../assets/images/svg/chain.svg';
import themeColors from '../../assets/styles/themeColors';

const ChainStyled = styled(Chain)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundSecondaryLight};
`;

const ChainIcon = (props) => <ChainStyled {...props} />;

ChainIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

ChainIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default ChainIcon;
